import script from "./posts.vue?vue&type=script&setup=true&lang=js"
export * from "./posts.vue?vue&type=script&setup=true&lang=js"

import "./posts.vue?vue&type=style&index=0&id=f9154330&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9154330"]])

export default __exports__